import React, { useMemo } from "react";
import { StyleSheet, TextStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";
import Text from "../components/Text";

export type ListAnnotationProps = {
    value: string;
    style?: TextStyle;
};

const ListAnnotation: React.FC<ListAnnotationProps> = ({ value, style }) => {
    const styles = useStyles();
    return <Text style={[styles.text, style]}>{value}</Text>;
};

const useStyles = () => {
    const { gridSize, fonts, colors } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                text: {
                    ...fonts.bodySmall,
                    alignSelf: "stretch",
                    alignContent: "flex-start",
                    flexDirection: "row",
                    paddingHorizontal: gridSize / 2,
                    marginTop: gridSize,
                    color: colors.greyAccessible,
                },
            }),
        [fonts, gridSize, colors],
    );
};

export default ListAnnotation;
